<template>
  <div id="AccountSummaryEmail" class="Main-Content">

    <iframe-modal ref="iframeModal"></iframe-modal>
    <Page
      :title="$t('Summary Emails')"
    >
      <Layout>
        <LayoutSection>
          <Card>
            <!-- <CardSection> -->
              <Filters
                ref="filters"
                :filters="[
                  {
                    key: 'fromDate',
                    label: this.$t('Start Date'),
                    type: 'date',
                    required: true
                  },
                  {
                    key: 'toDate',
                    label: this.$t('End Date'),
                    type: 'date'
                  },
                  {
                    key: 'type',
                    label: $t('Type'),
                    type: 'select',
                    options: [
                      { label: $t('Weekly'), value: 'weekly' },
                      { label: $t('Monthly'), value: 'monthly' }
                    ],
                    required: false
                  }
                ]"
                :shortcuts="[
                  {
                    label: $t('Type'),
                    items: [
                      { label: $t('Weekly'), onAction: () => setType('weekly') },
                      { label: $t('Monthly'), onAction: () => setType('monthly') }
                    ]
                  }
                ]"
                :applied-filters="filter"
                @update="updateFilter"
                :query="false"
                required
              />
            
              <DataTable
                :columns="[
                  {
                    key: 'fromDate',
                    label: $t('From Date'),
                    format: 'dateLong'
                  },
                  {
                    key: 'toDate',
                    label: $t('To Date'),
                    format: 'dateLong'
                  },
                  {
                    key: 'type',
                    label: $t('Type')
                  }
                ]"
                :row-actions="[
                  {
                    label: $t('View email'),
                    onAction: (row) => viewEmail(row.fileName)
                  }
                ]"
                :rows="formattedEmails"
                :loading="loadingState"
                :pagination="{
                  offset: offset,
                  limit: limit,
                  total: totalElements,
                  updateOffset: updateOffset,
                  updateLimit: updateLimit
                }"
              />
            <!-- </CardSection> -->
          </Card>
        </LayoutSection>
      </Layout>

    </Page>

  </div>
</template>

<script>
import _ from 'lodash'

import IframeModal from '../components/dialogue/IframeModal'
import Utils from '../classes/utils/Utils'

export default {
  name: 'AccountSummaryEmail',
  data () {
    return {
      loading: true,
      hasBothTypes: null,
      email: [],
      totalElements: null,
      totalLoading: true,
      filter: {
        fromDate: null,
        toDate: null,
        type: null
      },
      offset: 0,
      limit: 10,
      sortBy: {
        column: 'toDate',
        direction: 'desc'
      },
      cancelableEmails: null,
      cancelableTotals: null
    }
  },
  async mounted() {
    NProgress.start()
    await this.setFilterFromQuery(false)

    this.$watch('$route', async () => {
      await this.setFilterFromQuery(true)
    }, { deep: true })

    this.limit = this.getTableLimit('tableLimit') || 10
    this.cancelableEmails = Utils.makeCancelablePromise(
      this.api.getSummaryEmails(this.filter, this.limit, this.offset)
    )
    this.cancelableEmails.promise
      .then((data) => {
        this.hasBothTypes = data.hasBoth
        this.email = data.emails
        this.loading = false
      })
      .catch((e) => {
        if (!e.isCanceled) {
          this.apiCatch(e)
        }
      })
      .finally(() => {
        NProgress.done()
      })
    
    this.cancelableTotals = Utils.makeCancelablePromise(
      this.api.getSummaryEmailsTotal(this.filter)
    )
    this.cancelableTotals.promise
      .then((response) => {
        this.totalElements = response
        this.totalLoading = false
      })
      .catch((e) => {
        if (!e.isCanceled) {
          this.apiCatch(e)
        }
      })
  },
  computed: {
    loadingState() {
      return {
        rows: this.loading,
        totals: false,
        footer: this.totalLoading
      }
    },
    formattedEmails() {
      // console.log(this.email)
      let emails = this.email.map(e => {
        return {
          ...e,
          fromDate: e.startDate,
          toDate: e.endDate,
          type: this.getType(e.type)
        }
      })
      if (this.sortBy) {
        emails = _.orderBy(emails, [this.sortBy.column], [this.sortBy.direction])
      }
      return emails
    }
  },
  methods: {
    async setFilterFromQuery(makeApiCall = false) {
      if (this.$route.query) {
        this.filter = {}
        Object.keys(this.$route.query).forEach((k) => {
          if (this.$route.query[k]) {
            this.filter[k] = this.$route.query[k]
          } else {
            this.filter[k] = null
          }
        })
      }
      if (!this.filter.fromDate) {
        this.filter.fromDate = window.moment().startOf('month').format('YYYY-MM-DD')
      }

      await this.$router.replace({ name: 'AccountSummaryEmails', query: this.filter})
      .catch(this.duplicateRouteCatch)

      if (makeApiCall) {
        this.filterSummaryEmails(true)
      }
    },
    setType(type) {
      this.filter.type = type
      this.filterSummaryEmails()
    },
    updateLimit(limit) {
      this.setTableLimit('tableLimit', limit)
      this.limit = limit
      this.offset = 0
      this.filterSummaryEmails(false)
    },
    getType(type) {
      return type === 'weekly' ? this.$t('Weekly') : this.$t('Monthly')
    },
    updateOffset(offset) {
      this.offset = offset
      this.filterSummaryEmails(false)
    },
    updateFilter(filter) {
      this.filter = filter
      this.filterSummaryEmails()
    },
    async viewEmail(file) {
      // console.log(file)
      let html = await this.api.getSummaryEmailDownloadLink(file)
      this.$refs.iframeModal.show(html)
    },
    updateUrl() {
      this.$router.push({ name: 'AccountSummaryEmails', query: this.filter})
      .catch(this.duplicateRouteCatch)
    },
    filterSummaryEmails(refreshTotals = true) {
      this.updateUrl()
      NProgress.start()
      this.email = []
      this.loading = true
      this.cancelableEmails.cancel()
      this.cancelableEmails = Utils.makeCancelablePromise(
        this.api.getSummaryEmails(this.filter, this.limit, this.offset)
      )
      this.cancelableEmails.promise
        .then((data) => {
          this.email = data.emails
          this.hasBothTypes = data.hasBoth
        })  
        .catch((e) => {
          if (!e.isCanceled) {
            this.apiCatch(e)
          }
        })
        .finally(() => {
          this.loading = false
          NProgress.done()
        })

      if (refreshTotals) {
        this.totalElements = null
        this.totalLoading = true
        this.cancelableTotals.cancel()
        this.cancelableTotals = Utils.makeCancelablePromise(
          this.api.getSummaryEmailsTotal(this.filter)
        )
        this.cancelableTotals.promise
          .then((data) => {
            this.totalElements = data
            this.totalLoading = false
          })
          .catch((e) => {
            if (!e.isCanceled) {
              this.apiCatch(e)
            }
          })
      }
    }
  },
  components: {
    IframeModal
  }
}

</script>
